import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendReportFactory()
  .extendReportViewFactory('losses')
  .factory()

export {
  Provider as LossesReportProvider,
  useStore as useLossesReportStore,
}
